import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import axios from 'axios'

import TopBar from '../components/TopBar'
import CocktailList from '../components/CocktailList'

import '../styles/home.scss'

const Home = () => {
  const [cocktails, setCocktails] = useState([])
  const [search, setSearch] = useState([])
  const [cocktailsToDisplay, setCocktailsToDisplay] = useState([])
  const [isSearching, setIsSearching] = useState(false)

  useEffect(() => {
    if (isSearching) {
      setCocktailsToDisplay(search)
    } else {
      setCocktailsToDisplay(cocktails)
    }
  }, [search, isSearching])

  useEffect(() => {
    axios({
      method: 'get',
      url: `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/api/cocktails`,
      headers: { Authorization: sessionStorage.getItem('token') },
    })
      .then((response) => {
        setCocktails(response.data)
        setCocktailsToDisplay(response.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('veuillez vous connecter')
          sessionStorage.clear()
        } else {
          console.error(error)
          toast.error(error.message)
        }
      })
  }, [])

  return (
    <div className="Home">
      <TopBar setCocktails={setSearch} isSearching={setIsSearching} />
      <CocktailList cocktails={cocktailsToDisplay} />
    </div>
  )
}

export default Home
